<template lang="pug">
.k-landing-how-can-you-use-kintell.brand-light-aqua-20.py-10
  k-container.text-xs-center
    h2.k-landing-how-can-you-use-kintell__title.title--large.brand-dark-blue--text.font-weight-bold.pt-4.font-family--secondary How can you use Kintell?
    v-row(align="start" justify="center").k-landing-how-can-you-use-kintell__cards
      v-col(cols="12" md="3" lg="3" sm="6")
        .px-lg-8.mb-10
          .k-landing-how-can-you-use-kintell__card.relative
            v-img(:src="require('~kurfs/green-girl-on-laptop-sitting.svg')" height="110" width="86").k-landing-how-can-you-use-kintell__kurf
            k-kintell-card-widget(
              v-bind="cards.guitarTutor"
              hide-favourite
              hide-footer
              hide-reviews
            )
          .k-landing-how-can-you-use-kintell__card-description
            h3.title--small.font-weight-bold.mb-4.pt-2 Learn a new skill
            .paragraph--book.grey-2--text Whether you’d like to learn to cook, play the guitar, or become a better writer, we have an advisor to help with that.
      v-col(cols="12" md="3" lg="3" sm="6")
        .px-lg-8.mb-10
          .k-landing-how-can-you-use-kintell__card
            k-kintell-card-widget(
              v-bind="cards.marketingConsultant"
              hide-favourite
              hide-footer
              hide-reviews
            )
          .k-landing-how-can-you-use-kintell__card-description
            h3.title--small.font-weight-bold.mb-4.pt-2 Get on-demand advice
            .paragraph--book.grey-2--text Have an issue that needs immediate attention? Kintell advisors can be booked in at short notice to help you out.
      v-col(cols="12" md="3" lg="3" sm="6")
        .px-lg-8.mb-10
          .k-landing-how-can-you-use-kintell__card
            k-kintell-card-widget(
              v-bind="cards.medievalHistory"
              hide-favourite
              hide-footer
              hide-reviews
            )
          .k-landing-how-can-you-use-kintell__card-description
            h3.title--small.font-weight-bold.mb-4.pt-2 Deepen your knowledge
            .paragraph--book.grey-2--text Want to delve into the nitty gritty of a subject? We have advisors from all walks of life ready to have their brains picked.
      v-col(cols="12" md="3" lg="3" sm="6")
        .px-lg-8.mb-10
          .k-landing-how-can-you-use-kintell__card
            k-kintell-card-widget(
              v-bind="cards.careersInDesign"
              hide-favourite
              hide-footer
              hide-reviews
            )
          .k-landing-how-can-you-use-kintell__card-description
            h3.title--small.font-weight-bold.mb-4.pt-2 Be mentored by an expert
            .paragraph--book.grey-2--text Our advisors can help you on your learning journey by providing ongoing advice and support via video chat.
</template>

<script>
import { KintellCard, User } from '@/models'

export default {
  data () {
    const davidThompson = new User({
      firstName: 'David',
      lastName: 'Thompson',
      slug: 'david-thompson',
      avatarUrl: require('~images/users/david-thompson.jpg')
    })
    const sandraKoh = new User({
      firstName: 'Sandra',
      lastName: 'Koh',
      slug: 'sandra-koh',
      avatarUrl: require('~images/users/sandra-koh.jpg')
    })
    const williamRosen = new User({
      firstName: 'William',
      lastName: 'Rosen',
      slug: 'william-rosen',
      avatarUrl: require('~images/users/william-rosen.jpg')
    })
    const archieElford = new User({
      firstName: 'Archie',
      lastName: 'Elford',
      slug: 'archie-elford',
      avatarUrl: require('~images/users/archie-elford.jpg')
    })
    return {
      cards: {
        guitarTutor: {
          card: new KintellCard({
            title: 'Guitar Tutor',
            slug: 'guitar-tutor',
            status: 'published',
            skills: [
              { name: 'Acoustic' },
              { name: 'Electric' },
              { name: 'Performance' },
            ],
            user: davidThompson,
          }),
          advisor: davidThompson
        },
        marketingConsultant: {
          card: new KintellCard({
            title: 'Marketing Consultant',
            slug: 'marketing-consultant',
            status: 'published',
            skills: [
              { name: 'Marketing' },
              { name: 'Coaching' },
              { name: 'Growth Hacking' },
            ],
            user: sandraKoh,
          }),
          advisor: sandraKoh
        },
        medievalHistory: {
          card: new KintellCard({
            title: 'Medieval History',
            slug: 'medieval-history',
            status: 'published',
            skills: [
              { name: 'Middle Ages' },
              { name: 'Renaissance' },
              { name: 'Byzantine Empire' },
            ],
            user: williamRosen,
          }),
          advisor: williamRosen
        },
        careersInDesign: {
          card: new KintellCard({
            title: 'Careers in Design',
            slug: 'careers-in-design',
            status: 'published',
            skills: [
              { name: 'Goal-setting' },
              { name: 'Deadlines' },
              { name: 'Personal Development' },
            ],
            user: archieElford,
          }),
          advisor: archieElford
        },
      },
      girlOnLaptop: require('~kurfs/green-girl-on-laptop.svg'),
    }
  }
}
</script>

<style scoped lang="scss">
.k-landing-how-can-you-use-kintell {

  padding: 26px 0 0;

  &__card {
    margin-bottom: 26px;
    @include md-and-up {
      margin-bottom: 64px;
    }
  }

  &__card-description {
    margin: 0 auto;
    max-width: 287px;
  }

  &__title {
    margin-top: 30px;
    margin-bottom: 35px;
    @include md-and-up {
      margin-top: 0;
      margin-bottom: 64px;
    }
  }

  &__kurf {
    position: absolute;
    right: calc(50% - 105px);
    z-index: 2;
    top: -70px;
    display: none;

    @include md-and-up {
      display: block;
    }
  }

  @include sm-and-down {
    padding: 0 !important;
  }

  ::v-deep {
    .k-kintell-card-widget {
      margin: 0 auto;

      max-width: 206px;

      .k-card {
        box-shadow: 0 1.4113px 2.21381px rgba(56, 99, 102, .0196802), 0 3.39155px 5.32008px rgba(56, 99, 102, .0282725), 0 6.38599px 10.0172px rgba(56, 99, 102, .035), 0 11.3915px 17.869px rgba(56, 99, 102, .0417275), 0 21.3066px 33.4221px rgba(56, 99, 102, .0503198), 0 51px 80px rgba(56, 99, 102, .07) !important;
        pointer-events: none;
      }

      .v-chip {
        height: 14px !important;
        padding: 0 10px !important;
      }

      .k-kintell-card-skill-list {
        margin-bottom: 15px;

        .ma-1 {
          line-height: 10px !important;
        }

        .small-caps--small {
          font-size: 8px !important;
          line-height: 10px !important;
        }
      }

      .k-kintell-card-widget__title {
        font-size: 14px !important;
        line-height: 23px !important;
      }

      .k-kintell-card-widget__avatar {
        height: 70px !important;
        min-width: 70px !important;
        width: 70px !important;
      }
    }
  }

}
</style>
